export enum OtherSalaryMultiplierA {
Fixed,
Hours,
Days,
Quantity,
ExpressionType,
}
